import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

export default class BaseMeta extends Component {
  static propTypes = {
    canonicalUrl: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
  };

  render() {
    return (
      <Helmet>
        {this.props.title ? <title>{this.props.title}</title> : undefined}
        {this.props.canonicalUrl ? (
          <link rel="canonical" href={this.props.canonicalUrl} />
        ) : (
          undefined
        )}
        {this.props.description ? (
          <meta name="description" content={this.props.description} />
        ) : (
          undefined
        )}
      </Helmet>
    );
  }
}
